import ms from 'ms';

export const EMAIL_LIST_CACHE_TIME = ms('5m');

export type EmailList = {
    code: string;
    description: string;
    frequency: string;
    name: string;
    sequence: number;
    subscribed: boolean;
    type: string;
};

export type EmailListSlice = {
    lists: EmailList[];
    loaded: number;
    loading: boolean;
};

export const defaultEmailListSlice: EmailListSlice = {
    lists: [],
    loaded: 0,
    loading: false,
};

export const emptyEmailList: EmailList = {
    code: '',
    description: '',
    frequency: '',
    name: '',
    sequence: -1,
    subscribed: false,
    type: '',
};

// Must match the codes item-api checks for in email-subscription-service.ts
export const SUBSCRIBE_TO_ALL_EMAIL_LISTS = 'Subscribe All';
export const UNSUBSCRIBE_TO_ALL_EMAIL_LISTS = 'Unsubscribed All';
